module.exports = __webpack_public_path__ + "static/img/jiaxing.a3f70bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/jiaxing.png
// module id = qxmo
// module chunks = 1